
































import { CatalogueItemModel, PartyModel } from '@/libs/Api';
import { catalogueItemsStore } from '@/libs/catalogue-items/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { partiesStore } from '@/libs/parties/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';

@Component({ })
export default class CatalogItemSelect extends Page {

    loading = false;
    search = "";
    debounce: any = null;

    @Prop({ default: "" }) label!: string;
    @VModel() innerValue!: string;
    @Prop() placeholder!: string;
    @Prop() readonly!: boolean;
    @Prop() disabled!: boolean;
    @Prop() rules!: [ any[] ];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) hideDetails!: boolean;
    @Prop({ default: false }) multiple!: boolean;
    @Prop({ default: null }) catalogueItemType!: string | null;
    
    @Watch("innerValue")
    innerValueChanged (v: string) {
        this.$emit("change", v);
    }

    @Watch("search")
    searchChanged (v: string, p: string) {
        if (this.innerValue == null && v != p) {
            this.loadItems();
        }
        else if (this.innerValue != null && v != null && (v.length == 1 || v.length == 0)) {
            this.$emit("input", null);
        }
    }

    @Watch("partyId")
    @Watch("catalogueItemType")
    partyIdChanged () {
        this.loadItems();
    }

    get items(): CatalogueItemModel[] {
        return catalogueItemsStore.useGetter(CrudGetter.Data);
    }

    mounted () {
        this.loadItems();
    }

    loadItems () {
        this.loading = true;
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            var filters: Array<any> = [];
            if (this.innerValue != null && this.innerValue.toString().length > 0) {
                filters.push({
                    field: "id",
                    op: "eq",
                    comparand: this.innerValue,
                    junction: "and"
                });
            }
            else if (this.search != null && this.search.length > 0) {
                const parts = this.search.split(" ");
                const searchFilters = [];
                for (var p of parts) {
                    if (p?.length == 0)
                        continue;
                    searchFilters.push({
                        field: "name",
                        op: "c",
                        comparand: p.trim(),
                        junction: "or"
                    });
                }
                if (searchFilters.any()) {
                    filters.push({
                        field: "name",
                        op: "wrap",
                        comparand: searchFilters,
                        junction: "and"
                    });
                }
            }
            if (this.catalogueItemType) {
                filters.push({ field: 'catalogueItemType', op: 'eq', comparand: this.catalogueItemType! });
            }
            catalogueItemsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<CatalogueItemModel>({ field: "name", index: 1, order: "asc" }, filters, {
                pageIndex: 1,
                pageSize: 999
            }));
            this.subscribe(catalogueItemsStore, CrudReponse.GetAll).then((e: CatalogueItemModel[]) => {
                this.loading = false;
            });
        }, 300)
    }

}
